export const getAppInfo = state => {
    if (state.app.info.gate === undefined || state.app.info.appid === undefined){
        return undefined
    }
    return state.app.info
}

// export const getListApps = state => state.app.lists.data === undefined ? [] : state.app.lists.data
export const getListApps = state => state.app.config.data === undefined ? [] : state.app.config.data.listapps

export const getGateConf = state => state.app.gate.data